export default {"src":"/_next/static/media/prev.7975739f.svg","height":22,"width":12};